<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
        :model="formData"
        ref="ruleForm"
        label-width="140px"
        class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$T('汇款时间')"
              prop="pay_off_date"
              :rules="[{ required: true, message: $T('请输入汇款时间') }]"
            >
              <el-input
                type="text"
                :placeholder="$T('请输入汇款时间')"
                v-model="formData.pay_off_date"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$T('汇款单号')"
              prop="pay_off_id"
              :rules="[{ required: true, message: $T('请输入汇款单号') }]"
            >
              <el-input
                type="text"
                :placeholder="$T('请输入汇款单号')"
                v-model="formData.pay_off_id"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$T('线下支付凭证')">
              <PicUploader :fileList="formData.order_pics" :limit="1"></PicUploader>
              <div class="form-label-desc">{{ $T('上传支付凭证') }}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">
              {{ $T('确定提交') }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<style scoped>
</style>
<script>
import PicUploader from '@/components/picker/PicUploader.vue';

export default {
  name: 'ISaiApplyBeizhu',
  components: {
    PicUploader,
  },
  data() {
    return {
      saveLoading: false,
      row: {
        id: 0,
      },
      formData: {
        id: 0,
        pay_off_date: '',
        pay_off_id: '',
        order_pics: [],
      },
    };
  },
  mounted() {
    this.row.id = this.$route.query.id;
    if (this.row.id) {
      this.fetch();
    }
  },
  methods: {
    submitForm(formName) {
      const that = this;
      if (!that.formData.order_pics || !that.formData.order_pics.length) {
        that.$message.error(that.$T('请上传支付凭证'));
        return;
      }

      that.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        }
        that.saveLoading = true;
        that.$api.post(
          '/api/isai/beizhusave',
          {
            id: that.formData.id,
            order_pics: that.formData.order_pics,
            pay_off_id: that.formData.pay_off_id,
            pay_off_date: that.formData.pay_off_date,
          },
          () => {
            that.saveLoading = false;
            that.$message.success(that.$T('保存成功'));
            setTimeout(function () {
              rbLink(
                {
                  name: 'ISaiApplyDetail',
                  query: {
                    id: that.row.id,
                  },
                },
                'back'
              );
            }, 100);
          },
          (res) => {
            that.$message.error(res.msg);
            that.saveLoading = false;
          }
        );
      });
    },
    fetch() {
      const that = this;
      that.$api.post(
        '/api/isai/beizhudetail',
        {
          id: that.row.id,
        },
        (res) => {
          that.formData = Object.assign(
            {
              id: that.row.id,
              pay_off_date: '',
              pay_off_id: '',
              order_pics: [],
            },
            res.data || {}
          );
          if (!Array.isArray(that.formData.order_pics)) {
            that.formData.order_pics = [];
          }
        },
        (res) => {
          that.$message.error(res.msg);
        }
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// SaiApplyBeizhu.vue?f0fdb83c